import { selectAll } from 'd3-selection'
import { getLogPageForm, getFormUrl } from './get-log-page-form'
import { isPageHasChanges, setPageHasChanges, unsetPageHasChanges } from './page-has-changes'

export function initPageBeacon () {
  document.addEventListener('visibilitychange', sendBeaconIfPageChanged)
  selectAll('input')
    .all(node => {
      if (node.attr('name') !== 'files[]') {
        node
          .on('change', setPageHasChanges)
          .on('input', setPageHasChanges)
      }
    })
  selectAll('select')
    .all(node => {
      node
          .on('change', setPageHasChanges)
          .on('input', setPageHasChanges)
    })
  selectAll('textarea')
    .all(node => {
      if (node.attr('name') !== 'files[]') {
        node
          .on('change', setPageHasChanges)
          .on('input', setPageHasChanges)
      }
    })
  selectAll('.ql-editor')
    .on('keydown', setPageHasChanges)
    .on('paste', setPageHasChanges)
  window.addEventListener('unload', sendBeaconIfPageChanged)
  window.addEventListener('pagehide', sendBeaconIfPageChanged)
  window.addEventListener('beforeunload', sendBeaconIfPageChanged)
}

export function sendBeaconIfPageChanged (isFetch = false) {
  console.log("Fetching??")
  console.log(isFetch)
  if (isPageHasChanges()) {
    let promise = sendBeacon(isFetch)
    unsetPageHasChanges()
    return promise
  }
}

function sendBeacon (isFetch = false) {
  let url = getFormUrl()
  let form = getLogPageForm()
  if (typeof isFetch === "boolean" && isFetch) {
    // Use fetch and wait for it to complete
    return fetch(url, {
      method: 'POST',
      body: form,
      // Optionally include headers if needed (FormData doesn't need Content-Type)
    })
  } else {
    navigator.sendBeacon(url, form)
  }
}